import { render } from "./MultipSelect.vue?vue&type=template&id=579d7bea&ts=true"
import script from "./MultipSelect.vue?vue&type=script&lang=ts"
export * from "./MultipSelect.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__